import * as React from "react";
import { ImagesContext } from "../Context";

interface Props {
  isBadgeShowing?: boolean;
}

const LoadingPatientRoster: React.FC<Props> = ({ isBadgeShowing = false }) => {
  const images = React.useContext(ImagesContext);

  return (
    <div
      className="loading-container"
      style={{ height: isBadgeShowing ? "45vh" : "53.8vh" }}
    >
      <img alt="Loading" src={images.new_large_spinner_src} />
      <h3>Loading...</h3>
      <p>
        We are loading your patient roster.
        <br />
        Please wait; do not leave this page.
      </p>
    </div>
  );
};

export default LoadingPatientRoster;
